const UTMIFY_SCRIPT_ID = 'utmify-utms-script';

export function loadUtmify(): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById(UTMIFY_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = UTMIFY_SCRIPT_ID;
  script.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
  script.setAttribute('data-utmify-prevent-xcod-sck', '');
  script.setAttribute('data-utmify-prevent-subids', '');
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}
